<div class="tbc-cnt">
    <div *ngFor="let item of dataSet; let i=index" class="tbc" [ngClass]="{'tbc-others' : i > 0, 'disabled': item.disabled, 'active' : activeIndex == i}"
        (click)="onTbcClick(item, i)">
        <!-- <span>{{getvalue(item)}}</span> -->
        <span style="margin-right:1vw;" [style.margin-left.vw]="getMarginLeft(i)">{{'breadCrumb.' + item.action | translate}}</span>
    </div>
</div>
